import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useTaxruleset, useTaxrulesetRef } from './state';

export function TaxRulesPage() {
  const ref = useTaxrulesetRef();
  const state = useTaxruleset((snapshot) => snapshot);
  const [taxYear, setTaxYear] = useState('2026');
  const [ruleVersion, setRuleVersion] = useState('1.0');
  const publishing = state.matches('publishing');
  return (
    <main className="mx-auto max-w-3xl px-6 py-12 text-foreground">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">Rules register</p>
      <h1 className="mt-3 text-3xl font-semibold tracking-tight">Publish tax rules</h1>
      <p className="mt-2 max-w-xl text-muted-foreground">Set the tax year and rule version used by new return files.</p>
      <div className="mt-8 grid max-w-md gap-5">
        <div className="grid gap-2">
          <Label htmlFor="tax-year">Tax year</Label>
          <Input
            id="tax-year"
            data-jr-key="tax-year"
            value={taxYear}
            onChange={(event) => setTaxYear(event.target.value)}
          />
        </div>
        <div className="grid gap-2">
          <Label htmlFor="rule-version">Rule version</Label>
          <Input id="rule-version" value={ruleVersion} onChange={(event) => setRuleVersion(event.target.value)} />
        </div>
        {state.matches('error') && (
          <p className="text-sm text-destructive">We couldn’t publish these rules. Check the values and try again.</p>
        )}
        <Button
          data-jr-key="publish-tax-rules"
          disabled={publishing}
          onClick={() => {
            const year = Number(taxYear);
            if (!Number.isInteger(year) || year < 1900 || year > 2200 || ruleVersion.trim().length === 0) return;
            ref.send({ type: 'taxruleset.publish', taxYear: year, ruleVersion: ruleVersion.trim() });
          }}
        >
          {publishing ? 'Publishing…' : 'Publish tax rules'}
        </Button>
      </div>
    </main>
  );
}
